import { combineReducers } from "redux";
// import { reducer as formReducer } from 'redux-form';

import admin from "./admin_reducer";
import adminError from "./admin_error_reducer";
import manageUsers from "./manageUsers_reducer";
import transactions from "./transactions_reducer";
import loaderSet from "./loader_reducer";
import manageCustomers from "./manageCustomers";

export default combineReducers({
  admin,
  adminError,
  manageUsers,
  transactions,
  loaderSet,
  manageCustomers,
});
